var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$style.stubPreloaderForm,
    _vm.$style[`_layout-${_vm.layout}`],
    { [_vm.$style._isVertical]: _vm.isVerticalModal }]},[_c('div',{class:_vm.$style.items},_vm._l((8),function(n){return _c('div',{key:n,class:_vm.$style.item})}),0),_c('div',{class:_vm.$style.button},[_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }